/* KG custom JS */

/* KG Work Hero — start */
(function () {
  function setActive(buttons, active) {
    buttons.forEach(function (btn) {
      var on = btn === active;
      btn.classList.toggle("is-active", on);
      btn.setAttribute("aria-pressed", on ? "true" : "false");
    });
  }

  function setFilteredOut(el, hide) {
    if (!el) return;
    el.hidden = hide;
    el.classList.toggle("is-kg-filtered-out", hide);
  }

  function applyFilter(key) {
    document.querySelectorAll("[data-kg-work-category]").forEach(function (item) {
      var category = item.getAttribute("data-kg-work-category") || "";
      var show = key === "all" || category === key;
      var shell = item.hasAttribute("data-kg-work-item")
        ? item
        : item.closest(".shopify-section") || item;
      setFilteredOut(shell, !show);
    });

    document.querySelectorAll(".kg-more-work").forEach(function (section) {
      var cards = section.querySelectorAll("[data-kg-work-item]");
      if (!cards.length) return;
      var anyVisible = false;
      cards.forEach(function (card) {
        if (!card.classList.contains("is-kg-filtered-out")) anyVisible = true;
      });
      var shell = section.closest(".shopify-section") || section;
      setFilteredOut(shell, !anyVisible);
    });
  }

  function initWorkHero(section) {
    var buttons = Array.prototype.slice.call(
      section.querySelectorAll("[data-kg-work-filter]")
    );
    if (!buttons.length) return;

    buttons.forEach(function (btn) {
      btn.addEventListener("click", function () {
        setActive(buttons, btn);
        applyFilter(btn.getAttribute("data-kg-work-filter") || "all");
      });
    });
  }

  function initWorkHeros() {
    document.querySelectorAll(".kg-work-hero").forEach(initWorkHero);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initWorkHeros);
  } else {
    initWorkHeros();
  }

  document.addEventListener("shopify:section:load", function (event) {
    var section = event.target.querySelector(".kg-work-hero");
    if (section) initWorkHero(section);
  });
})();
/* KG Work Hero — end */

/* KG Work Index — start */
(function () {
  function initWorkIndex(section) {
    var rows = section.querySelectorAll("[data-kg-work-row]");
    var media = section.querySelector("[data-kg-work-media]");
    var img = section.querySelector(".kg-work-index__media-img");
    var tag = section.querySelector(".kg-work-index__preview-tag");
    var desc = section.querySelector(".kg-work-index__preview-desc");

    if (!rows.length || !media) return;

    function showPreview(row) {
      var bg = row.getAttribute("data-kg-work-bg") || "#30011E";
      var nextTag = row.getAttribute("data-kg-work-tag") || "";
      var nextDesc = row.getAttribute("data-kg-work-desc") || "";
      var nextImg = row.getAttribute("data-kg-work-img") || "";

      media.style.backgroundColor = bg;

      if (tag) tag.textContent = nextTag;
      if (desc) desc.textContent = nextDesc;

      if (!img) return;

      if (nextImg) {
        img.removeAttribute("srcset"); img.removeAttribute("sizes"); img.src = nextImg;
        img.alt = row.querySelector(".kg-work-index__row-name")
          ? row.querySelector(".kg-work-index__row-name").textContent.trim()
          : "";
        img.hidden = false;
      } else {
        img.removeAttribute("srcset"); img.removeAttribute("src");
        img.hidden = true;
      }
    }

    rows.forEach(function (row) {
      row.addEventListener("mouseenter", function () {
        showPreview(row);
      });
      row.addEventListener("focus", function () {
        showPreview(row);
      });
    });
  }

  function initWorkIndexes() {
    document.querySelectorAll(".kg-work-index").forEach(initWorkIndex);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initWorkIndexes);
  } else {
    initWorkIndexes();
  }

  document.addEventListener("shopify:section:load", function (event) {
    var section = event.target.querySelector(".kg-work-index");
    if (section) initWorkIndex(section);
  });
})();
/* KG Work Index — end */

/* KG Before After — start */
(function () {
  function getTileWidth(track) {
    var first = track.firstElementChild;
    if (!first) return 0;
    var styles = window.getComputedStyle(track);
    var gap = parseFloat(styles.columnGap || styles.gap) || 0;
    return first.getBoundingClientRect().width + gap;
  }

  function getMaxIndex(track) {
    var tileW = getTileWidth(track);
    if (!tileW || !track.parentElement) return 0;
    var visible = Math.max(1, Math.round(track.parentElement.clientWidth / tileW));
    return Math.max(0, track.childElementCount - visible);
  }

  function goTo(track, index) {
    var tileW = getTileWidth(track);
    var maxIdx = getMaxIndex(track);
    var next = Math.min(maxIdx, Math.max(0, index));
    track._kgBaIdx = next;
    track.style.transform = "translateX(" + -next * tileW + "px)";
  }

  function initCarousel(section) {
    var track = section.querySelector("[data-kg-ba-track]");
    var prev = section.querySelector("[data-kg-ba-prev]");
    var next = section.querySelector("[data-kg-ba-next]");
    if (!track) return;

    track._kgBaIdx = track._kgBaIdx || 0;
    goTo(track, track._kgBaIdx);

    if (prev) {
      prev.addEventListener("click", function () {
        goTo(track, (track._kgBaIdx || 0) - 1);
      });
    }

    if (next) {
      next.addEventListener("click", function () {
        goTo(track, (track._kgBaIdx || 0) + 1);
      });
    }

    window.addEventListener("resize", function () {
      goTo(track, track._kgBaIdx || 0);
    });
  }

  function isCoarsePointer() {
    return window.matchMedia("(hover: none), (pointer: coarse)").matches;
  }

  function initTiles(section) {
    var tiles = section.querySelectorAll("[data-kg-ba-tile]");
    var coarse = isCoarsePointer();

    tiles.forEach(function (tile) {
      if (coarse) {
        tile.addEventListener("click", function () {
          tile.classList.toggle("is-comparing");
        });
        return;
      }

      tile.addEventListener("mouseenter", function () {
        tile.classList.add("is-comparing");
      });

      tile.addEventListener("mouseleave", function () {
        tile.classList.remove("is-comparing");
      });

      tile.addEventListener("pointerdown", function () {
        tile.classList.add("is-comparing");
      });

      tile.addEventListener("pointerup", function () {
        tile.classList.remove("is-comparing");
      });

      tile.addEventListener("pointercancel", function () {
        tile.classList.remove("is-comparing");
      });
    });
  }

  function initBeforeAfter(section) {
    initCarousel(section);
    initTiles(section);
  }

  function initAll() {
    document.querySelectorAll(".kg-before-after").forEach(initBeforeAfter);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }

  document.addEventListener("shopify:section:load", function (event) {
    var section = event.target.querySelector(".kg-before-after");
    if (section) initBeforeAfter(section);
  });
})();
/* KG Before After — end */

/* KG Case Study Compare — start */
(function () {
  function setPos(slider, percent) {
    percent = Math.min(100, Math.max(0, percent));
    var before = slider.querySelector("[data-kg-compare-before]");
    var line = slider.querySelector("[data-kg-compare-line]");
    var handle = slider.querySelector("[data-kg-compare-handle]");

    if (before) {
      before.style.clipPath = "inset(0 " + (100 - percent) + "% 0 0)";
    }
    if (line) line.style.left = percent + "%";
    if (handle) handle.style.left = percent + "%";

    slider.setAttribute("aria-valuenow", String(Math.round(percent)));
    slider.dataset.kgComparePos = String(percent);
  }

  function posFromEvent(slider, event) {
    var rect = slider.getBoundingClientRect();
    if (!rect.width) return 50;
    var clientX = event.touches && event.touches[0] ? event.touches[0].clientX : event.clientX;
    return ((clientX - rect.left) / rect.width) * 100;
  }

  function initCompare(slider) {
    if (!slider || slider.dataset.kgCompareReady === "1") return;
    slider.dataset.kgCompareReady = "1";

    var dragging = false;

    function move(event) {
      if (!dragging) return;
      if (event.cancelable) event.preventDefault();
      setPos(slider, posFromEvent(slider, event));
    }

    function stop() {
      dragging = false;
    }

    slider.addEventListener("pointerdown", function (event) {
      dragging = true;
      slider.setPointerCapture(event.pointerId);
      setPos(slider, posFromEvent(slider, event));
    });

    slider.addEventListener("pointermove", move);
    slider.addEventListener("pointerup", stop);
    slider.addEventListener("pointercancel", stop);
    slider.addEventListener("lostpointercapture", stop);

    slider.addEventListener("keydown", function (event) {
      var current = parseFloat(slider.dataset.kgComparePos || "50");
      var next = current;
      if (event.key === "ArrowLeft") next = current - 2;
      if (event.key === "ArrowRight") next = current + 2;
      if (event.key === "Home") next = 0;
      if (event.key === "End") next = 100;
      if (next === current) return;
      event.preventDefault();
      setPos(slider, next);
    });
  }

  function initAll() {
    document.querySelectorAll("[data-kg-compare]").forEach(initCompare);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }

  document.addEventListener("shopify:section:load", function (event) {
    var slider = event.target.querySelector("[data-kg-compare]");
    if (slider) {
      slider.dataset.kgCompareReady = "0";
      initCompare(slider);
    }
  });
})();
/* KG Case Study Compare — end */

/* KG Product Support Blocks — start */
(function () {
  function copyById(html, root, id, sectionId) {
    var source = html.getElementById(id + "-" + sectionId);
    var destination = root.querySelector("#" + id + "-" + sectionId);
    if (source && destination) {
      destination.innerHTML = source.innerHTML;
      destination.classList.toggle("hidden", source.classList.contains("hidden") || !source.textContent.trim());
    }
  }

  function applySupportVariant(event) {
    var html = event && event.data && event.data.html;
    var sectionId = event && event.data && event.data.sectionId;
    if (!html || !sectionId) return;

    var root = document.querySelector('product-info[data-section="' + sectionId + '"]');
    if (!root) {
      root = document.querySelector(".kg-product-support, .kg-product-design-build");
    }
    if (!root) return;

    [
      "KgSupportHours",
      "KgSupportBlurb",
      "KgSupportPrice",
      "KgSupportRate",
      "KgSupportSaving",
      "KgSupportBuyLabel",
      "KgSupportUses",
      "KgSupportStage",
      "KgSupportTurnaround",
      "KgSupportScope",
    ].forEach(function (id) {
      copyById(html, root, id, sectionId);
    });

    var sourceTile = html.getElementById("KgSupportTile-" + sectionId);
    var destTile = root.querySelector("#KgSupportTile-" + sectionId);
    if (sourceTile && destTile) {
      var tileColor = sourceTile.getAttribute("data-tile-color") || "";
      var tileInk = sourceTile.getAttribute("data-ink-color") || "";
      var tileHours = sourceTile.getAttribute("data-hours") || "";
      destTile.style.backgroundColor = tileColor;
      destTile.style.color = tileInk;
      destTile.setAttribute("data-tile-color", tileColor);
      destTile.setAttribute("data-ink-color", tileInk);
      destTile.setAttribute("data-hours", tileHours);
    }

    var buyLabel = root.querySelector("#KgSupportBuyLabel-" + sectionId);
    var buttonText = root.querySelector(".product-form__submit span");
    if (buyLabel && buttonText && buyLabel.textContent.trim()) {
      buttonText.textContent = buyLabel.textContent.trim();
    }
  }

  if (typeof subscribe === "function" && typeof PUB_SUB_EVENTS !== "undefined") {
    subscribe(PUB_SUB_EVENTS.variantChange, applySupportVariant);
  }

  function collapsedReadMoreHeight(body) {
    var width = body.clientWidth;
    var clone = body.cloneNode(true);
    clone.setAttribute("aria-hidden", "true");
    clone.style.cssText =
      "position:absolute;left:0;top:0;visibility:hidden;pointer-events:none;height:auto;max-height:none;overflow:hidden;display:-webkit-box;-webkit-box-orient:vertical;-webkit-line-clamp:5;width:" +
      width +
      "px";
    body.parentNode.appendChild(clone);
    var height = Math.ceil(clone.getBoundingClientRect().height);
    clone.remove();

    if (!height) {
      var style = window.getComputedStyle(body);
      var lineHeight = parseFloat(style.lineHeight);
      if (!lineHeight || Number.isNaN(lineHeight)) {
        var fontSize = parseFloat(style.fontSize) || 17.5;
        lineHeight = fontSize * 1.55;
      }
      height = Math.round(lineHeight * 5);
    }

    return height;
  }

  function initReadMore(scope) {
    var root = scope || document;
    root.querySelectorAll("[data-kg-readmore]").forEach(function (body) {
      var wrap = body.closest(".kg-product-support__description") || body.parentElement;
      var btn = wrap && wrap.querySelector("[data-kg-readmore-btn]");
      if (!wrap || !btn) return;

      var more = btn.querySelector("[data-kg-readmore-more]");
      var less = btn.querySelector("[data-kg-readmore-less]");
      var collapsed = collapsedReadMoreHeight(body);
      var wasExpanded = wrap.classList.contains("is-expanded");

      body.style.height = "auto";
      var full = body.scrollHeight;

      if (full <= collapsed + 2) {
        wrap.classList.remove("is-clamped", "is-expanded");
        btn.classList.add("hidden");
        body.style.height = "";
        return;
      }

      wrap.classList.add("is-clamped");
      btn.classList.remove("hidden");

      if (wasExpanded) {
        body.style.height = "auto";
        btn.setAttribute("aria-expanded", "true");
        if (more) more.hidden = true;
        if (less) less.hidden = false;
      } else {
        body.style.height = collapsed + "px";
        wrap.classList.remove("is-expanded");
        btn.setAttribute("aria-expanded", "false");
        if (more) more.hidden = false;
        if (less) less.hidden = true;
      }

      if (btn.dataset.kgBound === "1") return;
      btn.dataset.kgBound = "1";

      btn.addEventListener("click", function () {
        if (wrap.classList.contains("is-animating")) return;
        wrap.classList.add("is-animating");

        var open = wrap.classList.contains("is-expanded");
        var start = body.getBoundingClientRect().height;

        body.style.height = start + "px";
        body.offsetHeight;

        if (open) {
          wrap.classList.remove("is-expanded");
          btn.setAttribute("aria-expanded", "false");
          if (more) more.hidden = false;
          if (less) less.hidden = true;
          body.style.height = collapsedReadMoreHeight(body) + "px";
        } else {
          wrap.classList.add("is-expanded");
          btn.setAttribute("aria-expanded", "true");
          if (more) more.hidden = true;
          if (less) less.hidden = false;
          body.style.height = body.scrollHeight + "px";
        }
      });

      body.addEventListener("transitionend", function (event) {
        if (event.propertyName !== "height") return;
        wrap.classList.remove("is-animating");
        if (wrap.classList.contains("is-expanded")) {
          body.style.height = "auto";
        }
      });
    });
  }

  function bootReadMore() {
    initReadMore(document);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", bootReadMore);
  } else {
    bootReadMore();
  }

  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(bootReadMore);
  }

  document.addEventListener("shopify:section:load", function (event) {
    initReadMore(event.target);
  });
})();
/* KG Product Support Blocks — end */


